import {
    apiRequest,
    processInput,
    processQueryParams
} from "@/utilities"

export const userSettingService = {
  createUserSetting(params) {
    const createRequest = {
      method: "POST",
      data: processInput(params)
    }

    return apiRequest("/api/user-settings", createRequest)
  }
}